export const isString = str => str !== null && typeof str !== 'undefined' && typeof str.valueOf() === 'string';

export const isEmptyString = str => isString(str) && str.length === 0;

// strip html and encodings (e.g. "<span lang="en"><b>a11y</b> &amp; co</span>" -> "a11y & co")
export const stripMarkup = str => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || '';
};

export default {
  isString,
  isEmptyString,
  stripMarkup,
};
